<template>
  <section v-if="modelValue" class="mt-8 mb-8 boxed-button-grid">
    <label
      v-for="option in Risk"
      :key="option"
      class="base-button"
      :class="{
        active: modelValue && modelValue.planningRisk === option,
      }"
      >{{ wt('risk', 'option', option) }}
      <input
        type="radio"
        :value="option"
        v-model="modelValue.planningRisk"
        :id="option"
        name="orderBacklogWorkReserve" />
    </label>
  </section>
</template>
<script lang="ts" setup>
import type { PropType } from 'vue'
import { Risk } from '@/schemas/general/enums'
import { useWidgetText } from '@/helpers/useWidgetText'

interface OfficePlanningRiskForm {
  planningRisk: Risk
}

const { wt } = useWidgetText('widget-texts-office')
const modelValue = defineModel({ type: Object as PropType<OfficePlanningRiskForm> })
</script>
